import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M10.343 3.945c.09-.543.56-.94 1.11-.94h1.093c.55 0 1.02.397 1.11.94l.149.894c.07.424.384.764.78.929.398.165.855.143 1.205-.107l.737-.527a1.125 1.125 0 0 1 1.45.12l.773.773c.39.39.44 1.002.12 1.45l-.527.738c-.25.35-.272.806-.107 1.203s.505.71.93.781l.893.149c.543.09.94.56.94 1.11v1.094c0 .55-.397 1.019-.94 1.11l-.893.148c-.425.071-.765.384-.93.781-.165.398-.143.854.107 1.204l.527.737c.32.448.269 1.061-.12 1.45l-.774.773a1.125 1.125 0 0 1-1.449.12l-.738-.526c-.35-.25-.806-.273-1.203-.108s-.71.506-.781.93l-.149.894c-.09.542-.56.94-1.11.94h-1.094c-.55 0-1.019-.398-1.11-.94l-.148-.894c-.071-.424-.384-.765-.781-.93-.398-.165-.854-.143-1.204.108l-.738.526c-.447.32-1.06.27-1.45-.12l-.773-.773a1.125 1.125 0 0 1-.12-1.45l.527-.737c.25-.35.273-.807.108-1.204s-.505-.71-.93-.78l-.894-.15c-.542-.09-.94-.56-.94-1.11v-1.093c0-.55.398-1.02.94-1.11l.894-.149c.424-.07.765-.384.93-.78.165-.398.143-.855-.107-1.205l-.527-.737a1.125 1.125 0 0 1 .12-1.45l.773-.773a1.125 1.125 0 0 1 1.45-.12l.737.527c.35.25.807.272 1.204.107s.71-.505.78-.93z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M15 12.005a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
    }, null, -1)
  ])))
}
export default { render: render }